/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultContactSegment } from '../../models/api-response-paged-result-contact-segment';
import { PagedRequestContactSegment } from '../../models/paged-request-contact-segment';

export interface SearchContactSegment$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestContactSegment
}

export function searchContactSegment(http: HttpClient, rootUrl: string, params: SearchContactSegment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultContactSegment>> {
  const rb = new RequestBuilder(rootUrl, searchContactSegment.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultContactSegment>;
    })
  );
}

searchContactSegment.PATH = '/v1/api/ui/contactSegment/search';
